import api from './client';

export const miscApi = {
  seed: () => api.post('/seed'),
  getPlatformInfo: () => api.get('/platform-info'),
  getCounties: () => api.get('/counties'),
  health: () => api.get('/health'),
  getPublicStats: () => api.get('/stats'),
};
